// =============================================================================
// reducers/siteReducer.js
//
// State for the sites loaded for the map.
//
// IMPORTANT — add to the rootReducer:
//   import siteReducer from '../views/TelecomKPIAnomalyDetection/reducers/siteReducer';
//   combineReducers({ ..., sites: siteReducer });
// =============================================================================
import {
	SITES_FETCH_REQUEST, SITES_FETCH_SUCCESS, SITES_FETCH_FAILURE,
} from '../constants/kpiConstants';

const initialState = {
	loading: false,
	loaded:  false,
	error:   null,
	items:   [],
};

export default function siteReducer(state, action) {
	if (state === undefined) state = initialState;

	switch (action.type) {
		case SITES_FETCH_REQUEST:
			return Object.assign({}, state, { loading: true, error: null });

		case SITES_FETCH_SUCCESS:
			return Object.assign({}, state, {
				loading: false,
				loaded:  true,
				items:   action.payload || [],
			});

		case SITES_FETCH_FAILURE:
			return Object.assign({}, state, { loading: false, error: action.payload });

		default:
			return state;
	}
}
